import { usePal, PalHead, PalIcon } from "./PalUI";

const PalServices = () => {
  const { c, isDark, ink, muted, dim, hair } = usePal();
  const s = c.services;
  return (
    <section aria-label={s.eyebrow} data-testid="pal-services">
      <PalHead eyebrow={s.eyebrow} title={s.title} accentLine={s.accentLine} />
      <div className={`mt-10 pt-8 border-t grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 ${hair}`}>
        {s.clusters.map((g) => (
          <section
            key={g.id}
            aria-label={g.label}
            className="rounded-2xl p-5 border"
            style={{ borderColor: `${g.color}55`, backgroundColor: isDark ? `${g.color}0f` : `${g.color}0a` }}
            data-testid={`pal-cluster-${g.id}`}
          >
            <div className="flex items-center justify-between gap-2">
              <PalIcon name={g.iconName} className="w-5 h-5" style={{ color: g.color }} />
              <span className={`text-[11px] font-semibold uppercase tracking-wider ${dim}`}>{g.status}</span>
            </div>
            <h3 className={`mt-4 text-[18px] font-semibold tracking-tight ${ink}`}>{g.label}</h3>
            <ul className="mt-3 space-y-1.5">
              {g.items.map((it) => (
                <li key={it} className={`flex gap-2 text-[14px] leading-snug ${muted}`}>
                  <span className="mt-[7px] w-1 h-1 rounded-full flex-shrink-0" style={{ backgroundColor: g.color }} />
                  {it}
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
      <p className={`mt-8 text-[15px] ${ink}`}>
        {s.accountability}{" "}
        <span className={dim}>{s.ecosystem.join(" · ")}</span>
      </p>
    </section>
  );
};

export default PalServices;
